module.exports = __webpack_public_path__ + "img/sweden.3c793d41.svg";